import { Navigate, Route, Routes } from "react-router-dom";
import { App as AntApp } from "antd";
import PlaybookShell from "./PlaybookShell";
import BrandBook from "./pages/BrandBook";
import ZiniHubAdminPrototype from "./pages/ZiniHubAdminPrototype";
import ZiniHubAdminUXWizard from "./pages/ZiniHubAdminUXWizard";
import ZiniHubCustPrototype from "./pages/ZiniHubCustPrototype";
import ZiniHubCustUXWizard from "./pages/ZiniHubCustUXWizard";
import ZiBuzzPrototype from "./pages/ZiBuzzPrototype";
import ZiBuzzUXWizard from "./pages/ZiBuzzUXWizard";
import ZiniPixelsPrototype from "./pages/ZiniPixelsPrototype";
import ZiniPixelsUXWizard from "./pages/ZiniPixelsUXWizard";
import SuperAdminPrototype from "./pages/SuperAdminPrototype";
import SuperAdminUXWizard from "./pages/SuperAdminUXWizard";
import { ENABLE_PROTOTYPE } from "./featureFlags";

export default function App() {
  return (
    <AntApp>
      <Routes>
        <Route path="/" element={<PlaybookShell />}>
          <Route index element={<Navigate to="/super-admin/wizard" replace />} />
          <Route path="brand-book" element={<BrandBook />} />
          {ENABLE_PROTOTYPE && <Route path="zinihub-admin/prototype" element={<ZiniHubAdminPrototype />} />}
          <Route path="zinihub-admin/wizard" element={<ZiniHubAdminUXWizard />} />
          {ENABLE_PROTOTYPE && <Route path="zinihub-cust/prototype" element={<ZiniHubCustPrototype />} />}
          <Route path="zinihub-cust/wizard" element={<ZiniHubCustUXWizard />} />
          {ENABLE_PROTOTYPE && <Route path="zinihub/prototype" element={<Navigate to="/zinihub-admin/prototype" replace />} />}
          <Route path="zinihub/wizard" element={<Navigate to="/zinihub-admin/wizard" replace />} />
          {ENABLE_PROTOTYPE && <Route path="zibuzz/prototype" element={<ZiBuzzPrototype />} />}
          <Route path="zibuzz/wizard" element={<ZiBuzzUXWizard />} />
          {ENABLE_PROTOTYPE && <Route path="zinipixels/prototype" element={<ZiniPixelsPrototype />} />}
          <Route path="zinipixels/wizard" element={<ZiniPixelsUXWizard />} />
          {ENABLE_PROTOTYPE && <Route path="super-admin/prototype" element={<SuperAdminPrototype />} />}
          <Route path="super-admin/wizard" element={<SuperAdminUXWizard />} />
          <Route path="*" element={<Navigate to="/super-admin/wizard" replace />} />
        </Route>
      </Routes>
    </AntApp>
  );
}
